<bit-dialog dialogSize="default" background="default" class="bv-import-error-dialog">
  <span bitDialogTitle>{{ "importError" | i18n }}</span>

  <div bitDialogContent>
    <p class="bv-import-dialog__message">{{ "resolveTheErrorsBelowAndTryAgain" | i18n }}</p>
    <div class="bv-import-error-dialog__table">
      <div class="bv-import-error-dialog__table-header">
        <span>{{ "type" | i18n }}</span>
        <span>{{ "description" | i18n }}</span>
      </div>
      @for (row of dataSource.data; track row.message) {
        <div class="bv-import-error-dialog__table-row">
          <span class="bv-import-error-dialog__type">{{ row.type }}</span>
          <span class="bv-import-error-dialog__description">{{ row.message }}</span>
        </div>
      }
    </div>
  </div>

  <ng-container bitDialogFooter>
    <div class="bv-import-dialog__footer bv-import-dialog__footer--end">
      <button bitButton bitDialogClose buttonType="primary" type="button">
        {{ "ok" | i18n }}
      </button>
    </div>
  </ng-container>
</bit-dialog>
